export const NUMBER_ITEM_PAGINATION = 12;

export const OFFSET_PAGINATION = 1;
